"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KicadTextCodec = void 0;
class KicadTextCodec {
    decode(raw) {
        let text = '';
        const transforms = [];
        let index = 0;
        while (index < raw.length) {
            if (raw.substring(index, index + 2) === '~{') {
                const close = raw.indexOf('}', index + 2);
                if (close > index + 2) {
                    const from = text.length;
                    text += raw.substring(index + 2, close);
                    transforms.push({ type: 'bar', from, to: text.length });
                    index = close + 1;
                    continue;
                }
            }
            text += raw[index];
            index++;
        }
        return { text, transforms };
    }
}
exports.KicadTextCodec = KicadTextCodec;
//# sourceMappingURL=KicadTextCodec.js.map